;(function () {
  'use strict'

  angular.module('contrast.auth').factory('AuthFactory', ['$http', AuthFactory])

  function AuthFactory($http) {
    return {
      getAuthMode: getAuthMode,
      getSAMLMetadata: getSAMLMetadata,
      isUserActive: isUserActive,
      togglePortal: togglePortal
    }

    function getAuthMode() {
      return $http.get('/Contrast/api/ng/settings/auth')
    }

    function getSAMLMetadata() {
      return $http.get('/Contrast/saml/metadata')
    }

    function isUserActive(isAdminPortal) {
      if (isAdminPortal) {
        return $http.head('/Contrast/api/ng/superadmin/users/current')
      }
      return $http.head('/Contrast/api/ng/users/current')
    }

    function togglePortal(isAdminPortal, orgUuid) {
      if (isAdminPortal) {
        return $http.get('/Contrast/api/ng/superadmin/users/portal/toggle', {
          params: {
            orgUuid: orgUuid
          }
        })
      }
      return $http.get('/Contrast/api/ng/profile/toggle')
    }
  }
})()
